var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('SubMenuTabTemplate',{attrs:{"icon":_vm.routeIcon(_vm.node),"text":_vm.routeDisplayName(_vm.node),"hide":_vm.hide,"to":{ name: _vm.node.name, params: _vm.$route.params }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }